import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';
import { XCircle } from 'lucide-react';

const PaymentCancel = () => {
  const navigate = useNavigate();
  const logoUrl = 'https://customer-assets.emergentagent.com/job_transport-app-29/artifacts/c2qih6ut_J%20%26%20S%20Logo%2001%20%20%282%29_1024x1024.jpg';

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-amber-50 flex items-center justify-center p-4">
      <Card className="max-w-lg w-full p-8 text-center">
        <img src={logoUrl} alt="Logo" className="h-16 w-16 mx-auto mb-6 object-contain" />
        
        <div className="space-y-6">
          <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto">
            <XCircle className="text-red-600" size={48} />
          </div>
          
          <div>
            <h2 className="text-3xl font-bold mb-2">Payment Cancelled</h2>
            <p className="text-gray-600">Your booking was not completed</p>
          </div>

          <Card className="p-4 bg-gray-50">
            <p className="text-sm text-gray-700">
              Don't worry! No charges have been made to your card.
            </p>
          </Card>

          <div className="flex gap-3">
            <Button 
              onClick={() => navigate('/')}
              variant="outline"
              className="flex-1 border-2"
            >
              Go Home
            </Button>
            <Button 
              onClick={() => navigate('/user')}
              className="flex-1 bg-gradient-to-r from-amber-500 to-yellow-600 hover:from-amber-600 hover:to-yellow-700"
            >
              Try Again
            </Button>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default PaymentCancel;